const endpoints = {
    entityList : "/entity/list",
    entityById : entity_id => `/entity/${entity_id}`,
    addRule: "/rule/create",
    updateRule: rule_id => `/rule/${rule_id}`,
    duplicateTemplate: template_id => `/template/${template_id}/duplicate`,
    template: "/template",
}

export default endpoints;